import { Sutl } from '../../../../sutl';
import { KeyedValueBridge } from './ValueBridge';
export class CallInListBridge extends KeyedValueBridge {
    constructor(state, control, controlInfo, powerState, transport, valueCallback, log) {
        super('callInList', state, control, () => [], controlInfo, powerState, transport, valueCallback, log);
        this.keyMap = {};
        this.ignoreUndefinedValue = false;
    }
    // This is a read-only control so convertFromParam will never be used. An implementation is
    // included in case we want to generalize this class for another control.
    convertFromParam(value) {
        if (value.values === null) {
            throw new Error(`can't convert null value`);
        }
        let key;
        for (const [k, v] of Object.entries(this.keyMap)) {
            if (value.id === v) {
                key = k;
                break;
            }
        }
        if (key === undefined) {
            throw new Error(`no key for id = ${value.id}`);
        }
        return { key, value: value.values };
    }
    convertToParam(key, value) {
        let id = this.keyMap[key];
        if (id === undefined) {
            id = Sutl.generateFirebaseId();
            this.keyMap[key] = id;
        }
        return { id, values: value !== null && value !== void 0 ? value : null };
    }
}
